import { Building2 } from 'lucide-react'
import { FaFacebookF, FaLinkedinIn } from 'react-icons/fa'
import { useSearchParams } from 'react-router-dom'

import { Card } from '@/shared/components/ui/card'

import { useLeads } from '../../hooks/useLeads'

export default function LeadSourceSummary({ activeSource, onSelectSource }) {
  const { meta } = useLeads()
  const [searchParams, setSearchParams] = useSearchParams()
  const currentSource = activeSource || searchParams.get('source') || 'all'

  const handleCardClick = (sourceId) => {
    const nextSource = currentSource === sourceId ? 'all' : sourceId
    if (onSelectSource) {
      onSelectSource(nextSource)
    } else {
      const nextParams = new URLSearchParams(searchParams)
      if (nextSource === 'all') {
        nextParams.delete('source')
      } else {
        nextParams.set('source', nextSource)
      }
      setSearchParams(nextParams)
    }
  }

  const SUMMARY = [
    {
      id: 'linkedin',
      title: 'LinkedIn',
      subtitle: 'Leads converted · units',
      value: meta?.linkedin || 0,
      footer: 'Click to filter LinkedIn leads',
      icon: FaLinkedinIn,
      iconBg: 'bg-blue-600',
    },
    {
      id: 'facebook',
      title: 'Facebook',
      subtitle: 'Leads converted · units',
      value: meta?.facebook || 0,
      footer: 'Click to filter Facebook leads',
      icon: FaFacebookF,
      iconBg: 'bg-blue-500',
    },
    {
      id: 'offline',
      title: 'Offline',
      subtitle: 'Leads converted · units',
      value: meta?.offline || 0,
      footer: 'Click to filter Offline leads',
      icon: Building2,
      iconBg: 'bg-emerald-600',
    },
  ]

  return (
    <div className="grid gap-6 lg:grid-cols-3">
      {SUMMARY.map((item) => {
        const Icon = item.icon
        const isActive = currentSource === item.id

        return (
          <Card
            key={item.id}
            onClick={() => handleCardClick(item.id)}
            className={`cursor-pointer rounded-3xl border p-5 shadow-sm transition-all hover:shadow-md ${
              isActive
                ? 'border-blue-500 bg-blue-50/30 ring-2 ring-blue-500/20'
                : 'border-gray-200 bg-white hover:border-gray-300'
            }`}
          >
            <div className="flex items-start gap-4">
              <div
                className={`flex h-12 w-12 items-center justify-center rounded-full ${item.iconBg}`}
              >
                <Icon className="h-6 w-6 text-white" />
              </div>

              <div>
                <h3 className="text-xl font-semibold">{item.title}</h3>

                <p className="text-sm text-muted-foreground">{item.subtitle}</p>
              </div>
            </div>

            <div className="mt-5">
              <p className="text-4xl font-bold">{item.value}</p>
            </div>

            <div className="mt-4 flex items-center justify-between">
              <span className="text-xs font-medium text-slate-500">
                {isActive ? 'Active filter • Click to reset' : item.footer}
              </span>
            </div>
          </Card>
        )
      })}
    </div>
  )
}
